<div class="modal-container-custom">
  <div class="modal-content-custom">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" id="sign-documents-close" (click)="activeModal.close()">
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title enabled-text">{{modalInputs.isInitialSign ? 'Sign Documents' : 'Resend Docs for Signing'}}
      </h4>
    </div>
    <div class="modal-body">
      <app-upload-sign-docs-form [modalInputs]="modalInputs" [container]="'modal'"
      [commonSignatories]="null" (formSubmitOrCancelEvent)="onSignUploadCancel($event)">
      </app-upload-sign-docs-form>
    </div>
  </div>